import React, { useState, useEffect } from "react";
import DOMPurify from "dompurify";
import Badge from "react-bootstrap/Badge";
import { Spinner, Row, Col, Form } from "react-bootstrap";
import DismissableModal from "components/DismissableModal";
import { compareDates, formatDateWithTime } from "services/MomentUtils";
import { NotesFilterConstants } from "lookup/NotesFilterConstants";
import { sendAuthenticatedAsyncRequest } from "services/AsyncRequestService";
import { showNotification } from "services/NotificationService";
import AddEditNoteModal from "components/ScrollableNotes/AddEditNoteModal";
import { BiEdit } from "react-icons/bi"; 
import WfItemNote from "./WfItemNote";
import Noter from "./Noter";

const AllNotesModal = ({ wfItemId, onNoteUpdate }) => {
  const [showModal, setShowModal] = useState(false);
  const [notes, setNotes] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState("All");

  const fetchNotes = () => {
    setLoading(true);
    setNotes([]);
    sendAuthenticatedAsyncRequest(
      `/swim/${wfItemId}/notes/list`,
      "GET",
      null,
      (response) => {
        const sortedNotes = response.data.sort((n1, n2) =>
          compareDates(n2.creationDate, n1.creationDate)
        );
        setNotes(sortedNotes);
        setLoading(false);
      },
      (error) => {
        setLoading(false);
        showNotification({
          title: "Unable to fetch notes",
          message: "An error occurred while fetching notes for the list.",
          position: "tr",
          type: "error",
        });
      }
    );
  };

  const handleModalOpen = (isOpen) => {
    setShowModal(isOpen);
    if (isOpen) {
      fetchNotes();
    }
  };

  const handleNewNoteAdded = (newNote) => {
    const updatedNotes = [newNote, ...notes].sort((n1, n2) =>
      compareDates(n2.creationDate, n1.creationDate)
    );
    setNotes(updatedNotes);
    if (onNoteUpdate) onNoteUpdate();
  };

  const handleNoteEdited = (editedNote) => {
    const updatedNotes = notes.map((n) =>
      n.noteId === editedNote.noteId ? { ...editedNote, isEdited: true } : n
    );
    setNotes(updatedNotes);
    if (onNoteUpdate) onNoteUpdate();
  };

  const filtersList = NotesFilterConstants.generalNotesFilter;
  const filteredNotes = notes.filter(note => filterType === 'All' || note.type === filterType);

  return (
    <DismissableModal
      openModalButtonText="Show All"
      openModalButtonSize="sm"
      openModalButtonStyle="light"
      show={showModal}
      onShow={() => handleModalOpen(true)}
      centered
      title="Notes and Comments"
    >
      <div style={{ padding: "0 15px", minHeight: "100px", maxHeight: "400px", overflowY: "auto" }}>
        {loading && <Spinner animation="border" size="sm" />}
        {!loading && filteredNotes.length === 0 && <span>No notes found for this filter.</span>}
        {!loading &&
          filteredNotes.map((note, idx) => (
            <React.Fragment key={idx}>
              <WfItemNote
                note={note}
                wfItemId={wfItemId}
                isModalItem={true}
              />
              {idx !== filteredNotes.length - 1 && <hr />}
            </React.Fragment>
          ))}
      </div>
      <Noter entityId={wfItemId} onNewNote={handleNewNoteAdded} entitySaveUrl="/wf/note" />
    </DismissableModal>
  );
};

const HscSwitchListNotes = ({ wfItemId, latestNote, onNoteUpdate }) => {
  return (
    <div>
      {latestNote ? <p> {latestNote} </p> : <span>No Notes</span>}
      <AllNotesModal wfItemId={wfItemId} onNoteUpdate={onNoteUpdate} />
    </div>
  );
};

export default HscSwitchListNotes;
